"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("ethers/utils");

var browser_1 = __importDefault(require("@walletconnect/browser"));

var _1 = require(".");

var WalletConnectWallet = function (_super) {
  __extends(WalletConnectWallet, _super);

  function WalletConnectWallet(opts) {
    var _this = _super.call(this) || this;

    _this.NeedUnlockWalletError = new Error("WalletConnect session not established");
    _this.NotSupportedError = new Error("Current Wallet Not Supported");
    _this._bridge = opts.bridge || "https://bridge.walletconnect.org";
    _this.connector = new browser_1.default({
      bridge: _this._bridge
    });
    return _this;
  }

  WalletConnectWallet.prototype.signMessage = function (message) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }

      _this.connector.signMessage([_this.connector.accounts[0], message]).then(function (signature) {
        return resolve(signature);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  WalletConnectWallet.prototype.signPersonalMessage = function (message) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(new Error("WalletConnect session not estabslished"));
        return;
      }

      _this.connector.signPersonalMessage([_this.connector.accounts[0], message]).then(function (signature) {
        return resolve(signature);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  WalletConnectWallet.prototype.sendTransaction = function (txParams) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }

      _this.connector.sendTransaction({
        from: txParams.from || "",
        to: txParams.to || "",
        data: txParams.data || "",
        value: new utils_1.BigNumber("" + txParams.value).toString() || "",
        gasPrice: new utils_1.BigNumber("" + txParams.gasPrice).toString() || "",
        gasLimit: new utils_1.BigNumber("" + txParams.gasLimit).toString() || ""
      }).then(function (txHash) {
        return resolve(txHash);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  WalletConnectWallet.prototype.signTransaction = function (txParams) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }

      _this.connector.signTransaction({
        from: txParams.from || "",
        to: txParams.to || "",
        data: txParams.data || "",
        value: new utils_1.BigNumber("" + txParams.value).toString() || "",
        gasPrice: new utils_1.BigNumber("" + txParams.gasPrice).toString() || "",
        gasLimit: new utils_1.BigNumber("" + txParams.gasLimit).toString() || ""
      }).then(function (txHash) {
        return resolve(txHash);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  WalletConnectWallet.prototype.sendCustomRequest = function (method, params) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        reject(_this.NeedUnlockWalletError);
        return;
      }

      _this.connector.sendCustomRequest({
        method: method,
        params: params
      }).then(function (txHash) {
        return resolve(txHash);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  WalletConnectWallet.prototype.getAddresses = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.connector.connected) {
        resolve([]);
      }

      resolve(_this.connector.accounts);
    });
  };

  WalletConnectWallet.prototype.loadNetworkId = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return resolve(_this.connector.chainId);
    });
  };

  WalletConnectWallet.prototype.isLocked = function () {
    return !this.connector.connected;
  };

  WalletConnectWallet.prototype.type = function () {
    return WalletConnectWallet.TYPE;
  };

  WalletConnectWallet.prototype.id = function () {
    return WalletConnectWallet.TYPE;
  };

  WalletConnectWallet.prototype.isSupported = function () {
    var isSupported = typeof window !== "undefined" && typeof window.location !== "undefined" && window.location.protocol !== "https:" && window.location.hostname !== "localhost";

    if (!isSupported) {
      throw this.NotSupportedError;
    }

    return isSupported;
  };

  WalletConnectWallet.prototype.name = function () {
    return "WalletConnect";
  };

  WalletConnectWallet.LABEL = "WalletConnect";
  WalletConnectWallet.TYPE = "WALLETCONNECT";
  return WalletConnectWallet;
}(_1.BaseWallet);

exports.default = WalletConnectWallet;